module.exports = __webpack_public_path__ + "static/media/ex1.fce49563.png";